import * as actions from './structure-home.actions'
import { CompanyCredits } from 'src/services/ds.service'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option, some } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'

export interface StructureHomeState {
  credits: Option<CompanyCredits[]>
}

export const creditsLense = Lens.fromProp<StructureHomeState>()('credits')

export const initialStructureHomeState: StructureHomeState = {
  credits: none
}

export const sameState: (s: StructureHomeState) => StructureHomeState = identity

export const structureHomeReducer: Reducer<
  actions.StructureHomeActions,
  StructureHomeState
> = actions.structureHomeActions.match({
  GetCompanyCreditsSuccess: action => creditsLense.set(some(action.credits)),
  GetCompanyCreditsFailed: _action => creditsLense.set(none),
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/home/structure/structure-home.reducer.ts